

export const Skills: Array<{ img: string, alt: string, name: string, description?: string }> = [
    {
        name: 'HTML',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/html-5_rGiMMLW38.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622307636',
        alt: 'HTML 5 Logo',
        description: 'Hyper Text Markup Language'
    },
    {
        name: 'CSS',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/css__UAqc8BtNG.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622297082',
        alt: 'CSS 3 Logo',
        description: 'Cascading Style Sheets'
    },
    {
        name: 'JS',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/javascript_exuyeEab2.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622305352',
        alt: 'JS Logo',
        description: 'Javascript'
    },
    {
        name: 'TS',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/typescript_BMyt8t0twAum.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622310077',
        alt: 'TS Logo',
        description: 'Typescript'
    },

    {
        name: 'Angular',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/angular_oOmE_CAu7b.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622289097',
        alt: 'Angular Javascript Framework',
        description: 'Angular Javascript Framework'
    },
    {
        name: 'React',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/react_qqf46oebE-.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622303356',
        alt: 'React Logo',
        description: 'React.js Javascript framework'
    },
    {
        name: 'Vue',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/vue_Hlaob2rpr.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622298636',
        alt: 'Vue Logo',
        description: 'Vue.js Javascript framework'
    },
    {
        name: 'Sass',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/sass_lthmrLvEZug.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622312490',
        alt: 'Sass Logo',
        description: 'Syntactically awesome style sheets'
    },
    {
        name: 'Tailwind CSS',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/tailwindcss_Ii06YhpKT.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622301922',
        alt: 'Tailwind CSS Logo',
        description: 'A utility-first CSS framework'
    },
    {
        name: 'Bootstrap',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/bootstrap_6Dtqmjj12.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622294868',
        alt: 'Bootstrap Logo',
        description: 'Bootstrap CSS Framework'
    },
    {
        name: 'Php',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/php_6IM5ESDI7t.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622300551',
        alt: 'Php Logo',
        description: 'Hypertext Preprocessor'
    },
    {
        name: 'Laravel',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/laravel_pka6IKCH3L.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622291262',
        alt: 'Laravel Logo',
        description: 'Laravel PHP framework'
    },
    {
        name: 'MySQL',
        img: 'https://ik.imagekit.io/omarkhaled/My_Portfolio/Skills/mysql_RGhZEJpnh.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1647622292557',
        alt: 'MySQL Logo',
        description: 'MySQL Database'
    },
]